const localStore = {
    setItem:(key:string,val:any)=>localStorage.setItem(key,JSON.stringify(val)),
    getItem:(key:string)=>{
        try {
            return JSON.parse(localStorage.getItem(key)!);
        } catch {
            localStorage.removeItem(key);
            return null;
        }
    },
    removeItem:(key:string)=>localStorage.removeItem(key)
}

export default localStore;
